import React, { useState } from 'react';
import './RechazoConfirmacionContent.css';

interface RechazoConfirmacionContentProps {
  anexoNombre: string;
  tipo: 'rechazo' | 'aprobacion';
  onCancelar: () => void;
  onConfirmarRechazo?: (motivo: string) => void;
  onConfirmarAprobacion?: () => void;
  procesando?: boolean;
}

const RechazoConfirmacionContent: React.FC<RechazoConfirmacionContentProps> = ({
  anexoNombre,
  tipo,
  onCancelar,
  onConfirmarRechazo,
  onConfirmarAprobacion,
  procesando = false
}) => {
  const [motivo, setMotivo] = useState('');
  const maxCharacters = 300;

  const handleConfirmar = () => {
    if (tipo === 'rechazo') {
      if (motivo.trim().length === 0) {
        alert('Por favor, indique el motivo del rechazo.');
        return;
      }
      onConfirmarRechazo?.(motivo.trim());
    } else {
      onConfirmarAprobacion?.();
    }
  };

  const getDescriptionText = () => {
    if (tipo === 'rechazo') {
      return (
        <>
          Estás a punto de rechazar el <strong>{anexoNombre}</strong>. Por favor, indique el motivo del
          rechazo en el campo siguiente.
        </>
      );
    } else {
      return (
        <>
          ¿Está seguro de aprobar el <strong>{anexoNombre}</strong>?
        </>
      );
    }
  };

  const getInfoText = () => {
    if (tipo === 'rechazo') {
      return 'Una vez confirmado, el anexo quedará registrado como rechazado y no podrá modificarse.';
    } else {
      return 'Una vez confirmado, quedará registrado como aprobado y no podrá modificarse.';
    }
  };

  const getConfirmButtonText = () => {
    return tipo === 'rechazo' ? 'Confirmar rechazo' : 'Confirmar aprobación';
  };

  const isConfirmDisabled = () => {
    return (tipo === 'rechazo' && motivo.trim().length === 0) || procesando;
  };

  return (
    <>
      <div className="rechazo-content">
        <p className="rechazo-description">
          {getDescriptionText()}
        </p>
        
        {tipo === 'rechazo' && (
          <div className="rechazo-form-group">
            <label htmlFor="motivoRechazo" className="rechazo-label">
              Indique el motivo del rechazo <span className="required">*</span>
            </label>
            <textarea
              id="motivoRechazo"
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              placeholder="Motivo de rechazo"
              className="rechazo-textarea"
              maxLength={maxCharacters}
              rows={3}
            />
            <div className="rechazo-counter">
              Caracteres {motivo.length}/{maxCharacters}
            </div>
          </div>
        )}

        <div className="rechazo-info-box">
          <div className="rechazo-info-icon">
            <i className="fa fa-info-circle"></i>
          </div>
          <div className="rechazo-info-text">
            {getInfoText()}
          </div>
        </div>
      </div>
      
      <div className="rechazo-footer">
        <div className="rechazo-buttons">
          <button
            type="button"
            onClick={onCancelar}
            className="rechazo-button-cancel"
            disabled={procesando}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleConfirmar}
            disabled={isConfirmDisabled()}
            className={`rechazo-button-confirm ${!isConfirmDisabled() ? 'enabled' : 'disabled'} ${tipo === 'aprobacion' ? 'aprobacion' : ''}`}
          >
            {procesando ? (
              <>
                <span style={{ marginRight: '8px' }} role="img" aria-label="Procesando">⏳</span>
                Procesando...
              </>
            ) : (
              getConfirmButtonText()
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default RechazoConfirmacionContent;